/**
 * Automatik-Einstellungen: welche Zeitschwellen der Betrieb selbst
 * bestimmen kann. Eine Liste für beide Formulare (Anlegen + Einstellungen),
 * damit Beschriftungen und Standardwerte nicht auseinanderlaufen.
 * 0 = die jeweilige Automatik ist aus.
 */

export interface AutomatikFeld {
  key: string;
  label: string;
  einheit: "Stunden" | "Tage";
  standard: number;
  hinweis: string;
}

export const AUTOMATIK_FELDER: AutomatikFeld[] = [
  {
    key: "newWarningHours", label: "Warnung bei unbeantworteter Anfrage",
    einheit: "Stunden", standard: 24,
    hinweis: "Neue Anfrage ohne Reaktion: nach so vielen Stunden werden Sie gewarnt (Notfälle schon nach einem Viertel der Zeit).",
  },
  {
    key: "quoteFollowupDays", label: "Angebots-Erinnerung",
    einheit: "Tage", standard: 7,
    hinweis: "Kunde antwortet nicht auf ein Angebot: nach so vielen Tagen bekommt er eine freundliche Erinnerung.",
  },
  {
    key: "terminErinnerungStunden", label: "Terminerinnerung",
    einheit: "Stunden", standard: 24,
    hinweis: "So viele Stunden vor einem Termin werden Kunde und Betrieb erinnert.",
  },
  {
    key: "abschlussErinnerungStunden", label: "Abschluss-Erinnerung",
    einheit: "Stunden", standard: 6,
    hinweis: "Ausführungstermin vorbei, Vorgang noch nicht abgeschlossen: nach so vielen Stunden werden Sie erinnert.",
  },
  {
    key: "bewertungNachTagen", label: "Bewertungs-Bitte",
    einheit: "Tage", standard: 2,
    hinweis: "So viele Tage nach dem Abschluss wird der Kunde einmal um eine Sterne-Bewertung gebeten.",
  },
  {
    key: "zahlungserinnerungNachTagen", label: "Zahlungserinnerung",
    einheit: "Tage", standard: 2,
    hinweis: "So viele Tage nach der Fälligkeit einer Rechnung bekommt der Kunde eine freundliche Erinnerung (Banklaufzeit einrechnen).",
  },
  {
    key: "nachfassNachTagen", label: "Nachfassen nach Ablehnung",
    einheit: "Tage", standard: 4,
    hinweis: "So viele Tage nach einer Angebots-Ablehnung fragt das System einmal nach, ob ein angepasstes Angebot gewünscht ist.",
  },
  {
    key: "archivNachTagen", label: "Automatisches Archiv",
    einheit: "Tage", standard: 14,
    hinweis: "Bezahlte Vorgänge verschwinden nach so vielen Tagen vom Brett ins Archiv.",
  },
];

/** Gespeicherte Werte (sla-JSON) mit den Standards zusammenführen. */
export function automatikWerte(sla: unknown): Record<string, number> {
  const roh = (sla && typeof sla === "object" ? sla : {}) as Record<string, unknown>;
  const erg: Record<string, number> = {};
  for (const f of AUTOMATIK_FELDER) {
    const v = Number(roh[f.key]);
    erg[f.key] = Number.isFinite(v) && v >= 0 ? v : f.standard;
  }
  return erg;
}
